import React from 'react';
import { Breakpoint } from '@noths/polaris-client-ribbons-base';

import { Picture } from '../../foundations/Picture/Picture';
import { PictureSource } from '../../foundations/Picture/PictureSource';
import type { ContentTileProps } from './types';
import { generateImgSrcSet } from './utils';
import * as styles from './ContentTiles.styles';

export const ContentTile = ({
  backgroundColor,
  href,
  imgSourcesByBreakpoint,
  isFourTileLayout,
  onClick,
  title,
}: ContentTileProps) => {
  const breakpointsInDecreasingOrder = Object.keys(imgSourcesByBreakpoint).sort(
    (a, b) => Breakpoint[a] - Breakpoint[b],
  );
  const smallestBreakpoint = breakpointsInDecreasingOrder[breakpointsInDecreasingOrder.length - 1];

  return (
    <a
      aria-label={title}
      css={[styles.gridItem, styles.link, isFourTileLayout && styles.gridItemFourLayout]}
      href={href}
      key={href}
      onClick={onClick}
    >
      <p
        css={styles.title}
        data-testid="content-tile-title"
        style={
          {
            '--backgroundColor': backgroundColor,
          } as styles.BackgroundColorCSSProperties
        }
      >
        <span>{title}</span>
      </p>
      <Picture
        imgCss={[
          styles.image,
          isFourTileLayout ? styles.imageAspectRatioFourTile : styles.imageAspectRatioTwoTile,
        ]}
        src={imgSourcesByBreakpoint[smallestBreakpoint][0]}
      >
        {breakpointsInDecreasingOrder.map((breakpoint) => (
          <PictureSource
            key={breakpoint}
            minBreakpoint={Breakpoint[breakpoint]}
            srcSet={generateImgSrcSet(imgSourcesByBreakpoint[breakpoint])}
          />
        ))}
      </Picture>
    </a>
  );
};
